import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { login, coachRegisterApiGet,getTournamentGet,getSpoonseGet,getTeamListGet,createTournamet, createMatch} from './MatchModel';
import Config from '../../Utility/Config';

export const getTournamentListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/tournament/list`, null);
    return getTournamentGet(response);
};

export const getMatchListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await post(`${Config.EXTENDED_URL}/match/list`, null);
    return response.data;
};
export const getMatchListByTournamentId = async (payload) => {
    console.log(process.env.EXTENDED_URL);
    const response = await post(`${Config.EXTENDED_URL}match/byTournamentId`, payload);
    return response?.data;
};

export const getSponserListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/sponser/list`, null);
    return getSpoonseGet(response);
};

export const getTeamListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/team/list`, null);
    return getTeamListGet(response);
};
export const getRefereeListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/referee/list`, null);
    return getTeamListGet(response);
};


export const getTournamentDetailsApi = async (tournamentId) => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/tournament/read/${tournamentId}`, null);
    return getTournamentGet(response);
};
export const createTournamentApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}admin/tournament/create`, data, null);
    return createTournamet(response);
};

export const createMatchApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}match/create`, data, null);
    return createMatch(response);
};
